import day from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat.js";
import duration from "dayjs/plugin/duration.js";
import localizedFormat from "dayjs/plugin/localizedFormat.js";
import customParseFormat from "dayjs/plugin/customParseFormat.js";
import localeData from "dayjs/plugin/localeData.js";
function camelToTitleCase(s) {
  if (!s) {
    return "";
  }
  const result = s.replace(/([A-Z])/g, " $1");
  return result.replace(/\b\w/g, (char) => char.toUpperCase());
}
function camelToUpperCase(s) {
  if (!s) {
    return "";
  }
  const result = s.replace(/([A-Z])/g, " $1").toUpperCase();
  return result.trim();
}
function capitalize(s) {
  if (s) {
    return s[0].toUpperCase() + s.slice(1);
  }
  return s;
}
function toBoolString(bool) {
  if (bool) {
    return "True";
  }
  return "False";
}
function toCommaSpaces(s) {
  if (s) {
    return s.replaceAll(",", ", ");
  }
  return s;
}
day.extend(advancedFormat);
day.extend(duration);
day.extend(localizedFormat);
day.extend(customParseFormat);
day.extend(localeData);
const dayjs = day;
function toDateString(date) {
  if (date) {
    return dayjs(date).format("L LT");
  }
  return "";
}
function toDuration(months) {
  return dayjs.duration(months, "M").toISOString();
}
function toDurationString(period) {
  return `${Math.floor(dayjs.duration(period).asMonths())} Months`;
}
function toMonths(period) {
  return dayjs.duration(period).asMonths().toFixed(0);
}
function toTitleCase(s) {
  if (!s) {
    return "";
  }
  return s.replace(/^custom_/, "").toLowerCase().replace(/[_-]/g, " ").split(" ").map(capitalize).join(" ");
}
function toUpperCase(s) {
  if (s) {
    return s.toUpperCase().replace(/[_-]/g, " ");
  }
  return s;
}
function toUrnSegment(s) {
  return s.toLowerCase().replace(/[^a-z0-9_]/g, "_");
}
export {
  camelToTitleCase,
  camelToUpperCase,
  capitalize,
  toBoolString,
  toCommaSpaces,
  toDateString,
  toDuration,
  toDurationString,
  toMonths,
  toTitleCase,
  toUpperCase,
  toUrnSegment
};
//# sourceMappingURL=index.js.map
